/**
 * subtitle_timeline.json — portable caption document for preview + Chromium export.
 */

import { exportTargetSizeForAspect } from '@/lib/videoExportFraming';
import { subtitleStyleToExportPayload } from '@/lib/subtitles/subtitleStyleConfig';
import { subtitleLayerToExportAnchors } from '@/lib/subtitles/subtitleLayer';

export const SUBTITLE_TIMELINE_VERSION = 1;

/** Build the canonical subtitle timeline sent with video export requests. */
export function buildSubtitleTimelineDocument({
  aspectRatio,
  style,
  layer,
  cues = [],
}) {
  const { width, height } = exportTargetSizeForAspect(aspectRatio);
  const exportAnchors = subtitleLayerToExportAnchors(layer);
  const stylePayload = subtitleStyleToExportPayload(style, layer, exportAnchors);
  const usesDevanagari = cues.some((c) => /[\u0900-\u097F]/.test(String(c.text || '')));
  const fonts = usesDevanagari
    ? ['Noto Sans Devanagari']
    : [stylePayload.font_family || 'Arial'].filter(Boolean);

  return {
    version: SUBTITLE_TIMELINE_VERSION,
    aspect_ratio: aspectRatio,
    frame: { width, height },
    style: stylePayload,
    layer,
    fonts,
    cues: cues.map((cue, index) => ({
      id: cue.id || `cue-${index}`,
      text: String(cue.text || ''),
      lines: Array.isArray(cue.lines) ? cue.lines.map(String) : undefined,
      start_time: Number(cue.start_time) || 0,
      playback_seconds: Math.max(0.01, Number(cue.playback_seconds) || 0.01),
      muted: Boolean(cue.muted),
    })).filter((c) => !c.muted && c.text.trim()),
  };
}
